export const toArtworkTaxonomyId = (value) => String(value)
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-|-$/g, '');

export const getArtworkTaxonomyOptions = (options, category, t) => options.map((value) => {
  const localized = t(`taxonomy.${category}.${toArtworkTaxonomyId(value)}`);
  return {
    value,
    label: localized === value ? value : `${value} — ${localized}`,
  };
});
